import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const ShieldIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="52%"
    viewBox="0 0 112 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M106.743 32.7042C106.678 29.2759 106.616 26.0372 106.616 22.904C106.616 20.4494 104.626 18.4594 102.171 18.4594C83.1629 18.4594 68.6905 12.9966 56.6271 1.26742C54.9014 -0.410887 52.1552 -0.410294 50.4301 1.26742C38.3679 12.9966 23.8979 18.4594 4.89071 18.4594C2.43608 18.4594 0.446054 20.4494 0.446054 22.904C0.446054 26.0378 0.384421 29.2777 0.31864 32.7066C-0.290575 64.6109 -1.12498 108.305 52.0728 126.745C52.5446 126.908 53.0364 126.99 53.5283 126.99C54.0202 126.99 54.5127 126.908 54.9838 126.745C108.186 108.305 107.353 64.6091 106.743 32.7042ZM53.5289 117.829C7.90478 101.255 8.59459 64.9481 9.20677 32.876C9.24351 30.9512 9.27907 29.0856 9.30396 27.2568C27.1063 26.5054 41.3422 21.1107 53.5289 10.4945C65.7167 21.1107 79.9551 26.506 97.7586 27.2568C97.7835 29.0851 97.819 30.9494 97.8558 32.8731C98.4674 64.9463 99.1566 101.254 53.5289 117.829Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M68.8353 48.0595L47.383 69.5106L38.2288 60.3564C36.493 58.6212 33.6786 58.6212 31.9434 60.3564C30.2077 62.0927 30.2077 64.9065 31.9434 66.6423L44.2403 78.9392C45.1079 79.8068 46.2458 80.2406 47.383 80.2406C48.5202 80.2406 49.6581 79.8068 50.5257 78.9392L75.12 54.3454C76.8564 52.6096 76.8564 49.7953 75.1206 48.0601C73.3854 46.3243 70.5711 46.3237 68.8353 48.0595Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
  </svg>
)
